var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@apollo/client';
import { Box, Loader } from '@pocketlaw/tetris';
import { Formik } from 'formik';
import { useCompanyFeatures } from 'app/domains/companies';
import { SearchTextFieldAllowedPropertiesForTextFieldSearch, SearchTypeEnum, } from 'shared/domains/apollo/generated/types';
import { SearchProviderDocument } from './SearchProvider.gql';
import { defaultColumnConfig } from './config/defaultColumnConfig';
import { makeTableCellConfig } from './config/makeTableCellConfig';
import { getActiveColumns } from './getActiveColumns';
import { sortColumns } from './sortColumns';
import { validateOrderBy } from './validateOrderBy';
export function SearchProvider(props) {
    const { children, referrer, userColumns = [], columns, filters, modifiers, query = '', orderBy, offset = 0, limit = 20, showDirty = false, onSubmit, } = props;
    const { data, loading: queryLoading } = useQuery(SearchProviderDocument);
    const { documentMetadataProperties } = data || {};
    const { isFeatureAvailable, loading: companyFeaturesLoading } = useCompanyFeatures();
    const isProjectsAvailable = isFeatureAvailable('projects');
    const metadataProperties = (documentMetadataProperties || []).map((col) => (Object.assign(Object.assign({}, col), { 
        // Map DMS name to search-service name
        name: `metadataDocument${col.name}` })));
    const custom = metadataProperties.reduce((acc, property) => {
        if (!property.companyId) {
            return acc;
        }
        const customProperty = makeTableCellConfig(property.name, {
            label: property.label,
            active: true,
        });
        return [...acc, customProperty];
    }, []);
    const columnsToSort = columns || defaultColumnConfig(custom);
    const sortedColumns = sortColumns(columnsToSort, userColumns);
    const activeColumns = getActiveColumns(sortedColumns, userColumns).filter((col) => {
        const { isHidden } = metadataProperties.find((property) => property.name === col.id) || {};
        if (isHidden || (col.id === 'metadataDocumentProjectIds' && !isProjectsAvailable)) {
            return false;
        }
        return true;
    });
    const initialValues = {
        referrer,
        query,
        filters,
        modifiers: Object.assign({ isFuzzy: true, searchType: SearchTypeEnum.All, searchFields: [
                {
                    field: SearchTextFieldAllowedPropertiesForTextFieldSearch.AllApplicable,
                },
            ] }, modifiers),
        columns: activeColumns,
        orderBy: validateOrderBy(orderBy),
        offset,
        limit,
    };
    const handleSubmit = (values, helpers) => __awaiter(this, void 0, void 0, function* () {
        if (onSubmit) {
            return onSubmit(values, helpers);
        }
        return values;
    });
    const loading = queryLoading || companyFeaturesLoading;
    if (loading) {
        return (<Box width="100%" height="100%" justifyContent="center" alignItems="center">
        <Loader size={12}/>
      </Box>);
    }
    return (<Formik initialValues={initialValues} onSubmit={handleSubmit} initialStatus={{ showDirty }}>
      {children}
    </Formik>);
}
